import React from 'react'

function Navigation({ links, paginate }) {
    const handleOnClick = (e) => {
        e.preventDefault();
        paginate(e.target.dataset.link)
    };

    return (
        <div className="nav-wrap">
            <nav>
                <span className="spaceX-hpLogo">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                        <path d="M23.933.079a9.818,9.818,0,0,1,2.13-.015A24,24,0,0,1,47.976,22.225,22.744,22.744,0,0,0,48,25.486a24.262,24.262,0,0,1-2.4,9.021A23.985,23.985,0,0,1,26.338,47.851a13.963,13.963,0,0,1-2.067.123A3.985,3.985,0,0,1,22.9,47.9q2.53-7.115,5.074-14.228c1.852-.034,3.706.012,5.558-.022a2.982,2.982,0,0,0,2.739-1.909c1.566-4.409,3.172-8.8,4.689-13.233a3.433,3.433,0,0,0,.189-2.114,2.745,2.745,0,0,0-1.953-1.75,8.268,8.268,0,0,0-2.338-.163c-2.377-.007-4.755.012-7.131-.011-.038.079-.116.237-.155.315Q23.8,31,18.018,47.209A24.032,24.032,0,0,1,.469,28.519,31.465,31.465,0,0,1,0,24.119a25.371,25.371,0,0,1,1.724-9A23.937,23.937,0,0,1,18.65.618C14.768,11.378,10.976,22.171,7.1,32.933a2.679,2.679,0,0,0,.762.049c1.414-.007,2.83,0,4.245,0,.193,0,.172-.269.253-.392,1.7-4.811,3.429-9.614,5.139-14.422a7.96,7.96,0,0,1,.335-.882c.886.015,1.773,0,2.659.01C18.63,22.5,16.787,27.723,14.9,32.925a1.714,1.714,0,0,0,.618.059c1.486-.014,2.971.009,4.457-.011,1.678-4.736,3.377-9.463,5.06-14.2a3.41,3.41,0,0,0-.181-3.006,2.881,2.881,0,0,0-2.351-1.2c-1.237-.037-2.475,0-3.713-.019,1.7-4.827,3.454-9.636,5.142-14.469" transform="translate(0 0)" fill="#343434" />
                        <path d="M5.165.106c.157-.179.437-.071.646-.1C6.542.018,7.272,0,8,.015,6.3,4.92,4.52,9.8,2.846,14.713c-.946.068-1.9.026-2.846.021C1.727,9.861,3.437,4.981,5.165.106" transform="translate(28.362 16.624)" fill="#343434" />
                    </svg>
                </span>
                <div className="ul-wrap">
                    <ul className="nav">
                        {links.sections.map(
                            (sec, index) => {
                                return (
                                    <li key={sec.ID}>
                                        <a href={sec.ID} onClick={handleOnClick} data-link={sec.ID} className={sec.ID} data-index={index}>
                                            {sec.text}
                                        </a>
                                    </li>
                                )
                            }
                        )}
                    </ul>
                </div>
            </nav>
        </div>
    )
}

export default Navigation
